import { combineReducers } from '@reduxjs/toolkit'

import user from './user/user'
import ownerArticle from './ownerArticle/ownerArticle'
import popup from './popup/alarmPopup'
import myhouse from './myhouse/myhouse'
import notice from './myhouse/notice'
import review from './myhouse/review'
import insurance from './myhouse/insurance'
import insuranceRegister from './myhouse/insuranceRegister'
import myhouseRegister from './myhouse/myhouseRegister'
import boardRegister from './myhouse/boardRegisterSlice'
import authentication from './myhouse/authentication'
import myhouseModal from './myhouse/modal'
import notify from './myhouse/notifySlice'
import main from './myhouse/mainSlice'
import setting from './myhouse/settingSlice'
import myhousePrice from './myhouse/price'
import myhouseToast from './myhouse/toast'
import unitPrice from './myhouse/unitPrice'
import ptpArticle from './myhouse/article'
import browser from './myhouse/browser'
import tax from './myhouse/tax'
import promotion from './myhouse/promotion'

import myhouseManagementFeeSlice from '@Root/slices/myhouse/managementFee'

const rootReducer = combineReducers({
  user,
  ownerArticle,
  popup,
  myhouse,
  notice,
  review,
  insurance,
  insuranceRegister,
  myhouseRegister,
  boardRegister,
  authentication,
  myhouseModal,
  notify,
  main,
  setting,
  myhousePrice,
  myhouseManagementFeeSlice,
  myhouseToast,
  unitPrice,
  ptpArticle,
  browser,
  tax,
  /*무료보험 프로모션 추가부분 시작*/
  promotion,
  /*무료보험 프로모션 추가부분 끝*/
})
export default rootReducer

export type RootState = ReturnType<typeof rootReducer>
